import { Navigate } from "react-router-dom";
import useAuth from "./useAuth";
import OneSignalWrapper from "../commonComponents/OneSignalWrapper";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const authToken = useAuth();

  return authToken ? <> <OneSignalWrapper/> {children} </> : <Navigate to="/on-boarding" />;
};

export default PrivateRoute;
